import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { LangProvider } from "./lib/i18n";
import { BagProvider } from "./lib/api";
import Home from "./pages/Home";
import Collection from "./pages/Collection";
import Product from "./pages/Product";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";

let lenis = null;

const SmoothScroll = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    let id;
    const raf = (time) => { lenis.raf(time); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); lenis = null; };
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (lenis) lenis.scrollTo(0, { immediate: true });
  }, [pathname]);
  return null;
};

const Chrome = () => {
  const { pathname } = useLocation();
  return pathname.startsWith("/admin") ? null : <Header />;
};

function App() {
  return (
    <LangProvider>
      <BagProvider>
        <BrowserRouter>
          <SmoothScroll />
          <Chrome />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/collections/:slug" element={<Collection />} />
            <Route path="/product/:id" element={<Product />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Toaster position="bottom-right" />
        </BrowserRouter>
      </BagProvider>
    </LangProvider>
  );
}

export default App;
